import React, { Component } from 'react';
/* Components */
import LoadingModal from '../common/loadingModal';

class ModalViewComments extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div
        data-close="ok"
        onClick={this.props.handleClose}
        className={this.props.showModal ? `container-modal` : `container-modal hide`}
      >
        <section className="module-title modal-title">
          <h2>{"Comentarios"}</h2>
          <a>
            <i data-close="ok" onClick={this.props.handleClose} className="fas fa-times-circle" />
          </a>
        </section>
        <div className={`box-modal max500`}>
          <section id="modal-edit" className="base-form">
            <div className="box-form islabel">
              <div>
                <label className="modal-label">
                  {""}
                </label>
              </div>
              <div>
                <div className="modal-input-view-comments">
                  {this.props.comments}
                </div>
              </div>
            </div>
          </section>
        </div>
        <div className={'box-form islabel top center modal-button-box '}>
          <div>
            <input
              data-close="ok"
              className="active"
              onClick={this.props.handleClose}
              type="button"
              value={"Cerrar"}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default ModalViewComments;



// WEBPACK FOOTER //
// ./source/client/components/flow_admin_detail/modalViewComments.jsx